import { MessageSquareText, ArrowRight } from "lucide-react";
import { PHONE_RAW, nextFridayLabel, scrollToId } from "./shared";

const LINKS = [
  ["01", "The Friday Model", "model"],
  ["02", "Pricing", "pricing"],
  ["03", "How It Works", "how"],
];

export default function Nav() {
  return (
    <header
      data-testid="navbar-header"
      className="fixed top-0 z-50 w-full border-b border-stone-800/80 bg-[#0c0a09]/85 px-4 py-3 backdrop-blur-xl sm:px-8"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4">
        <button
          data-testid="nav-brand"
          onClick={() => scrollToId("top")}
          className="flex items-center gap-3 text-left"
        >
          <span className="font-display text-2xl font-black uppercase leading-none tracking-tight text-bone">
            Friday<span className="text-amber-500">Stumps</span>
          </span>
          <span
            data-testid="nav-dispatch-badge"
            className="hidden items-center gap-2 whitespace-nowrap border border-stone-800 px-2.5 py-1 font-mono text-[10px] tracking-[0.2em] text-stone-400 md:flex"
          >
            <span className="pulse-dot h-1.5 w-1.5 rounded-full bg-amber-500" />
            {nextFridayLabel()}
          </span>
        </button>

        <nav className="hidden items-center gap-6 whitespace-nowrap lg:flex">
          {LINKS.map(([num, label, id]) => (
            <button
              key={id}
              data-testid={`nav-link-${id}`}
              onClick={() => scrollToId(id)}
              className="group font-mono text-[11px] uppercase tracking-[0.18em] text-stone-400 transition-colors duration-150 hover:text-bone"
            >
              <span className="text-amber-500/80">{num}</span>
              <span className="ml-1.5">{label}</span>
            </button>
          ))}
        </nav>

        <div className="flex shrink-0 items-center gap-2 whitespace-nowrap">
          <a
            data-testid="nav-sms-cta"
            href={`sms:${PHONE_RAW}`}
            className="flex min-h-[44px] items-center gap-2 whitespace-nowrap border border-stone-700 px-3 py-2 font-mono text-[11px] uppercase tracking-[0.15em] text-stone-300 transition-colors duration-150 hover:border-amber-500 hover:text-amber-500"
          >
            <MessageSquareText className="h-3.5 w-3.5" />
            <span className="hidden sm:inline">Text {PHONE_RAW}</span>
            <span className="sm:hidden">Text</span>
          </a>
          <button
            data-testid="nav-quote-cta"
            onClick={() => scrollToId("quote")}
            className="flex min-h-[44px] items-center gap-1.5 whitespace-nowrap bg-amber-500 px-3.5 py-2 font-mono text-[11px] font-semibold uppercase tracking-[0.15em] text-[#0c0a09] transition-colors duration-150 hover:bg-amber-400 active:bg-amber-600"
          >
            Friday Quote
            <ArrowRight className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>

      <div data-testid="nav-dispatch-mobile" className="mx-auto mt-2.5 flex max-w-7xl items-center justify-center gap-2 border-t border-stone-800/60 pt-2.5 font-mono text-[10px] uppercase tracking-[0.2em] text-stone-400 md:hidden">
        <span className="pulse-dot h-1.5 w-1.5 rounded-full bg-amber-500" />
        {nextFridayLabel()}
      </div>
    </header>
  );
}
